












import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { PaintingByNumbersModule, PaintingFormat, PaintingBoxUpdateState } from '../../../../store/modules/paintingByNumbers';
import { AppModule } from '../../../../store/modules/app'
import { DesignApi, Configuration, AssetApi } from '@/rest'
import { Asset } from '@/rest/models'

@Component({
  name: "box-edit",
  components: {
  }
})
export default class TitleImage extends Vue {
  private hash: string = ""
  private timestamp: string = ""
  private collageDru1AssetIds: number[] = []
  private scalePositions = [['-15','-100'],['-15','-100'],['-5','-75'],['0','-100']]

  get isLandscapeFormat() {
    return PaintingByNumbersModule.isLandscapeFormat
  }

  get isSquare() {
    return this.parts === '100000'
  }

  get title() {
    return PaintingByNumbersModule.title;
  }

  get designNr() {
    return PaintingByNumbersModule.boxDesign
  }

  get parts() {
    return PaintingByNumbersModule.parts
  }

  get dru1AssetId() {
    return PaintingByNumbersModule.previewAssetId
  }

  get imageAssetId() {
    let usage = "paintingimage"
    let info = PaintingByNumbersModule.paintingUsageAndInfo[usage]
    if (info) {
      let onlyAssetId = info.assetId
      if (onlyAssetId !== undefined) {
        return onlyAssetId
      }
    }
    return ''
  }

  get paintingBoxUpdateState() {
    return PaintingByNumbersModule.paintingBoxUpdateState
  }

  get zoomOnTitle() {
    /* return PaintingByNumbersModule.showTitle && PaintingByNumbersModule.title.trim() !== "" no zooming until box img has better quality*/
    return false
  }

  get transform() {
    let scale = '1'
    let translateX = '0'
    let translateY = '0'
    if (this.zoomOnTitle) {
      scale = '2'
      if(this.isLandscapeFormat) {
        translateX = this.scalePositions[2][0]
        translateY = this.scalePositions[2][1]
      } else {
        translateX = this.scalePositions[3][0]
        translateY = this.scalePositions[3][1]
      }
    }
    let scaleAndTranslate = 'scale(' + scale + ') translateX(' + translateX + 'px) translateY(' + translateY + 'px)'
    return scaleAndTranslate
  }

  get transition() {
    if (this.zoomOnTitle) {
      return 'all ease-in 0.5s'
    } else {
      return 'all ease-out 0.5s'
    }
  }

  get sessionId(): string {
    return AppModule.session.sessionId as string
  }

  get locale(): string {
    return AppModule.session.locale as string
  }

  @Watch('paintingBoxUpdateState')
  updatePuzzleBox(paintingBoxUpdateState: PaintingBoxUpdateState) {
    if(paintingBoxUpdateState === PaintingBoxUpdateState.UPDATING_BOX_ASSET) {
        let self = this
        this.createDru1().then(() => {
            self.getHash()
        });
    }
  }

  get format() {
    if (PaintingByNumbersModule.format === PaintingFormat.LANDSCAPE){
      return 'landscape'
    }
    return 'portrait'
  }

  createTimestamp() {
    let date = new Date();
    this.timestamp = date.getUTCFullYear().toString() + ((date.getUTCMonth() + 1) > 9 ? '' : '0') + (date.getUTCMonth() + 1).toString() + ((date.getUTCDate() + 1) > 9 ? '' : '0') + date.getUTCDate().toString() + (date.getUTCHours() > 9 ? '' : '0') +  date.getUTCHours().toString() + (date.getUTCMinutes() > 9 ? '' : '0') + date.getUTCMinutes().toString() + (date.getUTCSeconds() > 9 ? '' : '0') + date.getUTCSeconds().toString()
  }

  get link() {
    let url = ''
    if(this.hash) {
      url = '/cpapi/assetThumbnail3dMnZ/'
      url += this.sessionId
      url += '/' + this.dru1AssetId
      url += '/' + this.designNr
      url += '/' + this.parts
      url += '/' + this.format
      url += '/' + this.locale
      url += '/preview.png'
      url += '?timestamp=' + this.timestamp
      url += '&hash=' + this.hash
      if(this.title) {
        url += '&title=' + encodeURIComponent(this.title)
      }
    }
    return url
  }

  getHash(): Promise<void> {
    window.console.log("BoxEdit getHash dru1AssetId", this.dru1AssetId)
    this.createTimestamp()
    var self = this
    let path = '/cpapi/assetThumbnail3dMnZ/'+ this.dru1AssetId
    return new Promise<void>((resolve, reject) => {
        let designApi = new DesignApi(
            new Configuration({ basePath: '/rest'})
        )
        let generateHashRequest = {"value":path, "timestamp":self.timestamp};
        designApi.generateHash(generateHashRequest).then(
            (value) => {
                self.hash = value
                resolve()
            },
            (reason) => {
                window.console.log(reason)
                reject()
            });
      });
  }

  createDru1(): Promise<void> {
    var self = this
    return new Promise<void>((resolve, reject) => {
      let assetApi = new AssetApi(new Configuration({ basePath: '/rest'}))
      if(self.imageAssetId === '') {
        reject()
      }
      let assets: Asset[] = []
      Object.keys(PaintingByNumbersModule.paintingUsageAndInfo).forEach(function(key,index) {
        let collageAsset = PaintingByNumbersModule.paintingUsageAndInfo[key]
          var matches = key.match(/\d+$/);
          var pos = index;
          if(matches) {
            pos = Number(matches[0])
          }
          if(pos <= PaintingByNumbersModule.numberOfImages) {
              let asset: Asset = {};
              asset.id = collageAsset.assetId
              asset.rotation = collageAsset.rotation
              asset.ll = collageAsset.boundingBox.ll
              asset.ur = collageAsset.boundingBox.ur
              asset.pieces = PaintingByNumbersModule.parts
              if(asset.ur && asset.ur.length > 1 && asset.ll && asset.ll.length > 1) {
                  let height = asset.ur[1] - asset.ll[1];
                  let width = asset.ur[0] - asset.ll[0];
                  asset.format = height > width ? "H" : "Q"
              }
              assets.splice(pos - 1, 0, asset)
          }
      });
      if(assets.length == 1) {
        let createDru1Request = {"customProductType": "MNZ", "asset": assets[0], "sessionId" : this.sessionId}
        assetApi.createDru1(createDru1Request).then(
          (value) => {
            PaintingByNumbersModule.SetPreviewAssetId(value)
            PaintingByNumbersModule.SetPaintingBoxUpdateState(PaintingBoxUpdateState.UPDATED)
            resolve()
          },
          (reason) => {
            window.console.log(reason)
            reject()
          });
      } else {
        reject()
      }
    });
  }

  createDefaultDru1(): Promise<void> {
    //TODO
    var self = this
    return new Promise<void>((resolve, reject) => {
      let assetApi = new AssetApi(new Configuration({ basePath: '/rest'}))
      if(self.imageAssetId !== '') {
        reject()
      }
      var createDefaultDru1Request = {"pieceCount":this.parts, "format": this.format, "sessionId" : this.sessionId, "customProductType" : "MNZ"}
      assetApi.createDefaultDru1(createDefaultDru1Request).then(
          (value) => {
              PaintingByNumbersModule.SetPreviewAssetId(value)
              PaintingByNumbersModule.SetPaintingBoxUpdateState(PaintingBoxUpdateState.UPDATED)
              resolve()
          },
          (reason) => {
              window.console.log(reason)
              reject()
          });
    });
  }

  mounted() {
    var self = this
    if(this.imageAssetId === '') {
      this.createDefaultDru1().then(() => {
          self.getHash()
      });
    }else {
      this.$nextTick(() => {
        if(this.paintingBoxUpdateState === PaintingBoxUpdateState.UPDATING_BOX_ASSET) {
          this.createDru1().then(() => {
                self.getHash()
          });
        } else if(this.paintingBoxUpdateState === PaintingBoxUpdateState.UPDATED) {
          self.getHash()
        }
      })
    }
  }
}
